import * as React from 'react';
import { useRef, useEffect } from 'react';
import { addClass, Bem } from '../../utils/css.js';
import { useMergedRefs } from '../../utils/component-util.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './Tab.scss.js';
import { Icon } from '../Icon/Icon.js';

const renderTitle = (props, id, bem) => {
  let title;
  if (React.isValidElement(props.title)) {
    title = props.title;
  } else {
    let titleIcon = null;
    let titleText = props.title;
    if (props.iconName !== void 0) {
      titleIcon = /* @__PURE__ */ React.createElement(Icon, {
        color: props.iconColor,
        className: bem.element("title_icon")(),
        name: props.iconName
      });
      titleText = /* @__PURE__ */ React.createElement("span", {
        className: bem.element("title_text")()
      }, props.title);
    }
    title = /* @__PURE__ */ React.createElement("span", null, titleIcon, titleText);
  }
  return React.cloneElement(title, {
    id: id.copyWith(["link"]).toString()
  });
};
const Tab = React.forwardRef(function Tab2(props, ref) {
  const { tabKey, isSelected, isFocus, dataTa, className, htmlId, orientation, onChangeSelectedTab } = props;
  const bem = orientation === "horizontal" ? Bem.create("vai-tab") : Bem.create("vai-side-tab");
  const buttonRef = React.useRef(null);
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFocus && buttonRef.current && !isFirstRender.current) {
      buttonRef.current.focus();
    }
    isFirstRender.current = false;
  }, [isFocus]);
  const id = useId(htmlId, ["tab"]);
  const handleClick = () => {
    if (onChangeSelectedTab) {
      onChangeSelectedTab(tabKey);
    }
  };
  return /* @__PURE__ */ React.createElement("button", {
    id: id.toString(),
    "data-ta": dataTa,
    className: addClass(bem.block(isSelected && "selected"), className),
    key: tabKey,
    onClick: handleClick,
    ref: useMergedRefs(buttonRef, ref),
    tabIndex: !isSelected ? -1 : void 0
  }, renderTitle(props, id, bem));
});

export { Tab };
